import { mapEnum } from 'Commons/helpers/utils/Formatter';
import enums from './Enums';

const BATCH_PAYMENT_FILTER_TYPE = mapEnum(enums.filters);

export { BATCH_PAYMENT_FILTER_TYPE };
